<template>
  <div v-if="visible" class="cookie-consent-banner">
    <p>
      We use cookies to count visits (Google Analytics).
      <a :href="privacyUrl" target="_blank">What we keep</a>
    </p>
    <button @click="acceptCookies">OK</button>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import {useCookies} from 'vue3-cookies'

// Initialize cookies API from vue3-cookies
const {cookies} = useCookies()

// State to control banner visibility
const visible = ref(false)

// URL for privacy policy (customize as needed)
const privacyUrl = '/privacy-policy'

// When the component mounts, check if consent cookie exists
onMounted(() => {
  const consent = cookies.get('cookieConsentAccepted')
  if (!consent) {
    visible.value = true
  }
})

// Handler to accept cookies
function acceptCookies() {
  // Set cookie "cookieConsentAccepted" with value 'true', expiration 30 days, sameSite lax
  cookies.set('cookieConsentAccepted', 'true', '30d', '/', '', false, 'lax')
  visible.value = false
}
</script>

<style scoped>
/* Shell furniture: legible on every page, old or redrawn (it was white on
   pale pink, i.e. unreadable, everywhere). */
.cookie-consent-banner {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: 12px;
  max-width: 40rem;
  margin: 0 auto;
  background: var(--sheet);
  color: var(--ink-2);
  border: 1.5px solid var(--ink);
  box-shadow: 0 10px 30px -12px rgba(20, 16, 26, .4);
  padding: 12px 14px 12px 18px;
  font-family: var(--text);
  text-align: left;
  display: flex;
  gap: 12px 18px;
  align-items: center;
  flex-wrap: wrap;
  z-index: 1000;
}

.cookie-consent-banner p {
  margin: 0;
  padding: 0;
  flex: 1 1 16rem;
  font-size: .88rem;
  line-height: 1.5;
  color: var(--ink-2);
}

.cookie-consent-banner a {
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.cookie-consent-banner button {
  appearance: none;
  background: var(--ink);
  color: var(--sheet);
  border: 1.5px solid var(--ink);
  border-radius: 0;
  padding: 10px 16px;
  margin: 0;
  cursor: pointer;
  font-family: var(--mono);
  font-size: .68rem;
  font-weight: 500;
  letter-spacing: .14em;
  text-transform: uppercase;
}
.cookie-consent-banner button:hover { background: #000; }
.cookie-consent-banner a:focus-visible, .cookie-consent-banner button:focus-visible { outline: 2.5px solid var(--red); outline-offset: 3px; }
</style>
